import React, { useState, useEffect } from "react";
import styles from "./Assessment.module.css";
import Header from "../../components/Header/Header";
import { Link } from "react-router-dom";
import CourseSidebar from "../../components/SideBar/CourseSidebar";
import SideBar from "../../components/SideBar/AdminSideBar";
import { history } from "../../_components/_helpers/history";

/* eslint-disable */

const QuizTaker = ({ quizData, submitAnswer}) => {
  const role = localStorage.getItem("role");
  const [count, setCount] = useState(0);
  const [quiz, setQuiz] = useState(null);
  const [answer, setAnswer] = useState({
    questionId: null,
    answerIds: [],
  });

  // Countdown timer state
  const initialTimer = parseInt(localStorage.getItem("timer") || "3600", 10); // Default to 1 hour in seconds
  const [timer, setTimer] = useState(initialTimer);

  useEffect(() => {
    // Load the initial question based on user role
    if (role === "user" && quizData && quizData.length > 0) {
      setQuiz(quizData[count]);
      setAnswer({ questionId: quizData[count].id, answerIds: [] });
    } else if (role === "admin") {
      setQuiz(quizData);
    }
  }, []);

  useEffect(() => {
    // Countdown timer
    if (history.location.pathname === "/viewassessment") {
      const intervalId = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer > 0) {
            const updatedTime = prevTimer - 1;
            localStorage.setItem("timer", updatedTime.toString()); // Save the updated time in seconds
            return updatedTime;
          } else {
            clearInterval(intervalId);
            alert("Time is up!");
            handleSubmitAnswer(); // Auto-submit when time is up
            return 0;
          }
        });
      }, 1000);

      return () => clearInterval(intervalId); // Cleanup on component unmount
    }
  }, []);

  useEffect(() => {
    // Cleanup timer from localStorage when leaving or completing the quiz
    return () => {
      if (history.location.pathname !== "/viewassessment") {
        localStorage.removeItem("timer");
      }
    };
  }, []);

  const handlePrevious = () => {
    if (count > 0) setCount(count - 1);
  };

  const handleRadioOption = (optionId) => {
    setAnswer((prev) => ({
      ...prev,
      answerIds: [optionId],
    }));
  };

  const handleCheckboxOption = (optionId) => {
    setAnswer((prev) => {
      const updatedAnswers = prev.answerIds.includes(optionId)
        ? prev.answerIds.filter((id) => id !== optionId)
        : [...prev.answerIds, optionId];
      return { ...prev, answerIds: updatedAnswers };
    });
  };

  const handleNext = () => {
    if (count < quizData.length - 1) setCount(count + 1);
  };

  const handleSubmitAnswer = async (e) => {
    if (e) e.preventDefault();

    if (answer.answerIds.length === 0) {
      alert("Please select an option before submitting.");
      return;
    }

    await submitAnswer(answer);
    if (count < quizData.length - 1) {
      handleNext();
    } else {
      alert("Quiz completed!");
      setTimeout(() => {
        localStorage.removeItem("questions");
        localStorage.setItem("timer", timer); // Reset timer in localStorage for future quizzes
        window.location.assign("/assessments");
      }, 2000);
    }
  };

  // Convert seconds to mm:ss format for display
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };


  return (
    <>
      <div className="main-wrapper">
        <Header />
        {role === "admin" && <SideBar />}
        {role === "user" && <CourseSidebar />}

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <div className="page-sub-header">
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/admindashboard">Home</Link>
                      </li>
                      <li className="breadcrumb-item active">Assessments</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {role === "user" && (quiz ? (
              <form onSubmit={handleSubmitAnswer}>
                    <p>Timer: {formatTime(timer)}</p>
              <h2>Taking Quiz: {quiz?.text}</h2>
              <div className={styles.questionBlock}>
                <h4>{quiz?.text}</h4>
                <ul className={styles.optionsList}>
                  {quiz.type === "option" &&
                    quiz?.options.map((opt, i) => (
                      <li key={i} className={styles.optionItem}>
                        <input
                          type="radio"
                          name="question"
                          value={opt.id}
                          onChange={() => handleRadioOption(opt.id)}
                        />
                        <label>{opt.text}</label>
                      </li>
                    ))}
                  {quiz.type === "multi-option" &&
                    quiz?.options.map((opt, i) => (
                      <li key={i} className={styles.optionItem}>
                        <input
                          type="checkbox"
                          name="question"
                          value={opt.id}
                          onChange={() => handleCheckboxOption(opt.id)}
                        />
                        <label>{opt.text}</label>
                      </li>
                    ))}
                </ul>
              </div>
              <ul className="pagination mb-0">
                <li className="page-item" onClick={handlePrevious}>
                  <button type="button" className="page-link">
                    <i className="feather-chevron-left mr-2" />
                    Previous
                  </button>
                </li>
                <li className="page-item">
                  <button type="submit" className="page-link">
                    {count === quizData.length - 1 ? "Finish" : "Submit"}
                  </button>
                </li>
              </ul>
            </form>
            
            ) : (
              <div className="no-quiz">
                <h2>No Quiz Available</h2>
              </div>
            ))}
          </div>

          {role === "admin" && (quiz && quiz.length > 0 ? quiz.map((quizDoc, index) => (
              <div key={index}>
                <h2>Taking Quiz: {quizDoc?.text}</h2>
                <div className={styles.questionBlock}>
                  <h4>{quizDoc?.text}</h4>
                  <ul className={styles.optionsList}>
                    {quizDoc?.type === "option" &&
                      quizDoc?.options.map((opt, i) => (
                        <li key={i} className={styles.optionItem}>
                          <input type="radio" name={`question_${index}`} value={i} />
                          <label>{opt.text}</label>
                        </li>
                      ))}

                    {quizDoc?.type === "multi-option" &&
                      quizDoc?.options.map((opt, i) => (
                        <li key={i} className={styles.optionItem}>
                          <input type="checkbox" name={`question_${index}`} value={i} />
                          <label>{opt.text}</label>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            )):  (
              <div className="no-quiz">
                <h2>No Quiz Available</h2>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default QuizTaker;
